import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DhhpButtonModule } from '../core/dhhp-components/dhhp-button';
import { DhhpCardModule } from '../core/dhhp-components/dhhp-card';
// import { AppManagerModule } from '../core/dhhp-feature-components/app-manager';
import { GlobalMenuModule } from 'global-menu';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [DhhpButtonModule,DhhpCardModule, GlobalMenuModule]
})
export class DhhpComponentModule { }
